import React from 'react'
// import { Link, animateScroll as scroll } from 'react-scroll'

export default HeroScroll => {
  return (
    <div className="scroll-container">
      {/*<Link*/}
      {/*  className="button primary circle"*/}
      {/*  to="page-content"*/}
      {/*  duration={500}*/}
      {/*  smooth={true}*/}
      {/*>*/}
      {/*  <i className="fa fa-angle-down"></i>*/}
      {/*</Link>*/}
    </div>
  )
}
